/* src/app/shared/components/tooltip/tooltip.component.scss */
.tooltip-container {
  box-shadow: 0px 1px 2px 0px color-mix(in srgb, var(--cds-foreground-600) 30%, transparent), 0px 2px 6px 2px color-mix(in srgb, var(--cds-foreground-600) 15%, transparent);
  background: var(--cds-tooltip-background);
  padding: 4px 8px;
  position: relative;
  border-radius: 4px;
}
.tooltip-container span {
  font-size: 14px;
  font-weight: 400;
  color: var(--cds-text-strong);
  line-height: 150%;
}
.tooltip-container.bottom::before {
  position: absolute;
  content: "";
  left: calc(50% - 6px);
  top: -6px;
  border-style: solid;
  border-width: 0px 6px 6px 6px;
  border-color: transparent transparent var(--cds-tooltip-background) transparent;
}
.tooltip-container.top::before {
  position: absolute;
  content: "";
  left: calc(50% - 6px);
  bottom: -6px;
  border-style: solid;
  border-width: 6px 6px 0px 6px;
  border-color: var(--cds-tooltip-background) transparent transparent transparent;
}
.tooltip-container.start::before {
  position: absolute;
  content: "";
  top: calc(50% - 6px);
  right: -6px;
  border-style: solid;
  border-width: 6px 0px 6px 6px;
  border-color: transparent transparent transparent var(--cds-tooltip-background);
}
.tooltip-container.end::before {
  position: absolute;
  content: "";
  top: calc(50% - 6px);
  left: -6px;
  border-style: solid;
  border-width: 6px 6px 6px 0px;
  border-color: transparent var(--cds-tooltip-background) transparent transparent;
}
/*# sourceMappingURL=tooltip.component.css.map */
